import { Component, Input, OnDestroy } from "@angular/core";
import { ExerciseUser } from "../../../models/exercise.model";

@Component({
  selector: "ngx-exercise-history",
  styleUrls: ["./exercise-history.component.scss"],
  templateUrl: "./exercise-history.component.html",
})
export class ExerciseHistoryComponent implements OnDestroy {
  @Input() exerciseUsers?: ExerciseUser[];

  constructor() {}

  ngOnDestroy() {}
}
